import { useTranslations } from 'next-intl'

import { Form } from '@/shared/ui'

type Props = {
  placeholder?: string
  readOnly?: boolean
  disabled?: boolean
}

export const NameField = ({
  placeholder,
  readOnly = false,
  disabled = false,
}: Props) => {
  const t = useTranslations('account')

  return (
    <Form.Field name="name" readOnly={readOnly} disabled={disabled}>
      <Form.Label className="font-medium text-black">
        {t('name_label')}
      </Form.Label>
      <Form.TextField
        type="text"
        placeholder={placeholder || t('name_placeholder')}
        fullWidth
        readOnly={readOnly}
      />
      <Form.Message />
    </Form.Field>
  )
}
